import { Box, SimpleGrid } from '@chakra-ui/react'
import React from 'react'

const Written = () => {
  return (
   <Box>
    <SimpleGrid textAlign={"left"} p={3} ml={"30px"} gap={4}>
        <p><b>Top-Selling Healthcare Products:</b>
Accu-Chek Active - 100 Strips
|
Supradyn Multivitamin Tablets
|
DR Morepen BG 03 - 50 Strips
|
Dettol Antiseptic Liquid
|
Ensure Diabetes Care Vanilla Sugar Free Jar
|
Dettol Instant Hand Sanitizer
|
Everherb Shilajit
|
Softovac SF Powder
|
Pediasure Premium Chocolate Refill</p>
<Box mt={"6px"}>
    <p><b>Top-Selling Medicines:</b>
Dolovera Gel
|
Neurobion Forte
|
Chymoral Forte
|
Crocin Advance
|
Soframycin
|
Dexorange
|
Becadexamin
|
Folvite
|
Livogen
|
Becosules
|
Fourderm
|
Nurokind Plus
|
Burnol
|
Crocin 650
|
Mintop 5
|
Thrombophob
|
Evion 600</p>
<Box mt={"15px"}>
    <p><b>COVID-19 Preventatives:</b>
N95 Masks
|
Hand Sanitizers
|
Hand Gloves, Disinfectants, Thermometers & more!</p>
</Box >
<Box mt={"17px"}>
    <p><b>Your One-Stop Online Pharmacy - PharmEasy</b></p>
</Box>
<Box mt={"17px"}>
    <p><b>We've got India Covered!</b></p>
</Box>

<Box mt={"17px"}>
<p>We now deliver in 1000+ cities and towns across 22000+ pin codes. We thereby cover every nook and corner of the country! The major cities in which we deliver include Mumbai, Kolkata, Delhi, Bengaluru, Ahmedabad, Hyderabad, Chennai, Thane, Howrah, Pune, Gurgaon, Navi Mumbai, Jaipur, Noida, Lucknow, Ghaziabad & Vadodara.</p>
</Box>
<Box mt={"17px"}>
    <p><b>Say Goodbye to All Your Healthcare Worries With PharmEasy!</b></p>
</Box>
<Box mt={"17px"}>
<p>PharmEasy is here to help you take it easy! We are amongst one of India's top online pharmacy and medical care platforms. It enables you to order pharmaceutical and healthcare products online by connecting you to registered retail pharmacies and get them delivered to your home. We are an online medical store, making your purchase easy, simple, and affordable!</p>
</Box>
<Box mt={"17px"}>
    <p><b>How Are We Making Lives Simpler With Our Online Medical Store?</b></p>
</Box>
<Box mt={"17px"}>
<p>We now deliver in 1000+ cities and towns across 22000+ pin codes. We thereby cover every nook and corner of the country! The major cities in which we deliver include Mumbai, Kolkata, Delhi, Bengaluru, Ahmedabad, Hyderabad, Chennai, Thane, Howrah, Pune, Gurgaon, Navi Mumbai, Jaipur, Noida, Lucknow, Ghaziabad & Vadodara.</p>
</Box>
<Box mt={"17px"}>
    <p><b>Why Are We The Most Preferred Online Pharmacy?</b></p>
</Box>
<Box mt={"17px"}>
<p>We now deliver in 1000+ cities and towns across 22000+ pin codes. We thereby cover every nook and corner of the country! The major cities in which we deliver include Mumbai, Kolkata, Delhi, Bengaluru, Ahmedabad, Hyderabad, Chennai, Thane, Howrah, Pune, Gurgaon, Navi Mumbai, Jaipur, Noida, Lucknow, Ghaziabad & Vadodara.</p>
</Box>
<Box mt={"17px"}>
    <p><b>Sit Back & Relax While You Get Your Essentials Delivered Every Month!</b></p>
</Box>
<Box mt={"17px"}>
<p>Our doorstep delivery service is available in PAN-India across top cities like Bangalore, Delhi, Mumbai, Kolkata, Hyderabad, Gurgaon, Noida, Pune, etc. Our online medical store also allows you to choose from 1 lakh+ products including OTC products and medical equipment. PharmEasy is a one-stop online medical platform where you can also book diagnostic tests including blood tests, full-body checkups, and other preventive health check-ups at an affordable cost, right from the comfort of your home. We have partnered with trusted & certified labs that arrange for a sample pick-up from the convenience of your home. They also provide you with timely reports.</p>
</Box>
<Box mt={"17px"}>
    <p><b>Access medical and health information:</b></p>
</Box>
<Box mt={"17px"}>
<p>PharmEasy delivers reliable and accurate medical information that has been carefully written, vetted and validated by our health experts. Our specialists curate high-quality and most reliable literature about medicines, illnesses, lab tests, Ayurvedic and over the counter health products.</p>
</Box>
<Box mt={"17px"}>
    <p><b>We Believe in ‘Simplifying Healthcare, Impacting Lives!’</b></p>
</Box>
<Box mt={"17px"}>
<p>It’s tough to remember to refill every month, especially in the case of chronic diseases. PharmEasy’s subscription service not only ensures that you are reminded of your refills but also makes sure that you are never out on your medical essentials. You will get a reminder every month and your order will be delivered at your convenience!</p>
</Box>
<Box mt={"17px"}>
    <p><b>We've got India Covered!</b></p>
</Box>

</Box>
    </SimpleGrid>
   </Box>
  )
}

export default Written